export default (permission = '', permissions = []) => (permissions.findIndex((single) => single.name === permission) > -1);
